const InstagramRoundIcon = ({ color }: any) => {
  return (
    <svg width='34' height='34' viewBox='0 0 34 34' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle
        cx='17'
        cy='17'
        r='16'
        fill='url(#paint0_linear_5000_5713)'
        stroke='white'
        stroke-width='2'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M13.9996 10.834C12.4348 10.834 11.1663 12.1025 11.1663 13.6673V20.334C11.1663 21.8988 12.4348 23.1673 13.9996 23.1673H20.6663C22.2311 23.1673 23.4996 21.8988 23.4996 20.334V13.6673C23.4996 12.1025 22.2311 10.834 20.6663 10.834H13.9996ZM10.1663 13.6673C10.1663 11.5502 11.8825 9.83398 13.9996 9.83398H20.6663C22.7834 9.83398 24.4996 11.5502 24.4996 13.6673V20.334C24.4996 22.4511 22.7834 24.1673 20.6663 24.1673H13.9996C11.8825 24.1673 10.1663 22.4511 10.1663 20.334V13.6673ZM17.68 14.8286C17.2292 14.7617 16.7688 14.8387 16.3643 15.0486C15.9598 15.2585 15.6318 15.5906 15.4269 15.9977C15.222 16.4047 15.1507 16.8661 15.2231 17.316C15.2955 17.7659 15.5079 18.1816 15.8302 18.5038C16.1524 18.8261 16.5681 19.0385 17.018 19.1109C17.4679 19.1833 17.9293 19.112 18.3363 18.9071C18.7434 18.7022 19.0755 18.3742 19.2854 17.9697C19.4953 17.5652 19.5723 17.1048 19.5055 16.654C19.4373 16.1941 19.223 15.7684 18.8943 15.4397C18.5656 15.111 18.1399 14.8967 17.68 14.8286ZM15.9038 14.161C16.495 13.8542 17.1679 13.7417 17.8267 13.8394C18.4988 13.939 19.121 14.2522 19.6014 14.7326C20.0818 15.213 20.395 15.8352 20.4946 16.5073C20.5923 17.1661 20.4798 17.839 20.173 18.4303C19.8663 19.0215 19.3809 19.5009 18.7859 19.8004C18.191 20.0998 17.5167 20.2041 16.8591 20.0982C16.2015 19.9924 15.594 19.6819 15.1231 19.211C14.6521 18.74 14.3416 18.1325 14.2358 17.4749C14.13 16.8173 14.2342 16.143 14.5336 15.5481C14.8331 14.9531 15.3125 14.4677 15.9038 14.161ZM21.0002 12.584C20.586 12.584 20.2502 12.9198 20.2502 13.334C20.2502 13.7482 20.586 14.084 21.0002 14.084H21.0069C21.4211 14.084 21.7569 13.7482 21.7569 13.334C21.7569 12.9198 21.4211 12.584 21.0069 12.584H21.0002Z'
        fill='white'
      />
      <defs>
        <linearGradient
          id='paint0_linear_5000_5713'
          x1='2.00018'
          y1='34.1422'
          x2='36.2859'
          y2='1.99934'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#FFDD55' />
          <stop offset='0.526042' stop-color='#FF543E' />
          <stop offset='1' stop-color='#C837AB' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default InstagramRoundIcon
